import { mainStore } from "../mainStore";
import { chickenSkinMiddlewareForSkinEditor } from "../games/chicken/chickenUtils/chickenSkinMiddlewares";
import { GAME_IDS } from "../constants/gameIds";

export const removeAstrionaLoadingBanner = () => {
  window.parent.postMessage({ event: "game-loaded" }, "*");
};

export const getSkinMiddlewareForSkinEditor = (gameId) => {
  if (gameId === GAME_IDS.CHICKEN) {
    return chickenSkinMiddlewareForSkinEditor;
  }
  return (data) => data;
};

const onMessage = async (e) => {
  if (e.data.event === "access-token-received") {
    mainStore.setAccessToken(e.data.accessToken);
  } else if (e.data.event === "apply-skin") {
    mainStore.setSkinByGameSkinParser(getSkinMiddlewareForSkinEditor(mainStore.gameId)(e.data.skin));
  }
};

window.addEventListener("message", onMessage);
window.parent.postMessage({ event: "game-preloaded" }, "*");
